import { render, staticRenderFns } from "./DemForTrendSku.vue?vue&type=template&id=8cb8637a&"
import script from "./DemForTrendSku.vue?vue&type=script&lang=js&"
export * from "./DemForTrendSku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports